<div class="coupon">
  <div class="coupon__row">
    <app-clickable-row
      icon="icon-tag-outline"
      label="Promo code, rewards & gift cards"
      [(isOpen)]="isCouponExpanded"
    />
  </div>

  @if (isCouponExpanded()) {
    <div @slideInOut class="coupon__control">
      <div class="coupon__control-input">
        <app-input
          label="Promo code"
          buttonLabel="Check"
          [style]="InputStyle.Secondary"
          [buttonDisabled]="!couponControl() || isLocked()"
          [buttonLoading]="isCouponLoading()"
          (buttonClick)="onCouponCheckClick()"
          [(ngModel)]="couponControl"
        />
      </div>

      @if (isAuthenticated()) {
        <div class="coupon__control-input">
          <app-input
            label="Redeem reward points"
            type="number"
            buttonLabel="Redeem"
            [style]="InputStyle.Secondary"
            [buttonDisabled]="
              !rewardPointsControl() || isLocked() || isRewardPointsLoading()
            "
            [buttonLoading]="isRewardPointsLoading()"
            (buttonClick)="onRewardPointsRedeemClick()"
            [(ngModel)]="rewardPointsControl"
          />
        </div>

        <div class="coupon__control-info coupon-info">
          @let rewardWorth = rewardPointsWorth();
          <div class="coupon-info__label">
            <div class="coupon-info__label-text">Reward Points</div>
            <span class="coupon-info__label-caption">
              You have {{ availableRewardPoints() }} points
              @if (rewardWorth !== null) {
                ({{ rewardWorth | formattedCurrency: rewardMinorUnit() }})
              }
            </span>
          </div>

          @if (appliedRewardPoints() > 0) {
            <div class="coupon-info__actions">
              <span class="coupon-info__description">
                Applied {{ appliedRewardPoints() }} points (-{{
                  appliedRewardDiscount() | formattedCurrency: rewardMinorUnit()
                }})
              </span>

              <app-button
                [style]="ButtonStyle.Secondary"
                [disabled]="isLocked() || isRewardPointsLoading()"
                [loading]="isRewardPointsLoading()"
                (buttonClick)="onRewardPointsRemoveClick()"
              >
                Remove
              </app-button>
            </div>
          } @else {
            <span class="coupon-info__description">
              Apply points to reduce your checkout total.
            </span>
          }
        </div>
      }
    </div>
  }
</div>
